import {
  isNonNullable
} from "./chunk-K54LRIUM.mjs";

// lib/components/toggle/toggle-switch/toggle-switch.tsx
import classnames from "classnames";
import React from "react";
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
var ToggleSwitch = React.forwardRef(
  ({ classNames, value, label, disabled, style, onChange, isSmall, ...props }, ref) => {
    const width = isSmall ? 22 : 32;
    const height = isSmall ? 14 : 20;
    const padding = isSmall ? 1 : 2;
    const sliderRadius = isSmall ? 10 : 14;
    return /* @__PURE__ */ jsxs(
      "label",
      {
        ref,
        className: classnames("checkbox", classNames),
        style: {
          display: "flex",
          alignItems: "center",
          cursor: disabled ? "default" : void 0,
          opacity: disabled ? 0.5 : void 0,
          ...style
        },
        onClick: (e) => {
          e.stopPropagation();
        },
        ...props,
        children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "checkbox",
              checked: value,
              disabled,
              onChange: (e) => {
                onChange && onChange(e.target.checked);
              },
              style: {
                display: "none"
              }
            }
          ),
          /* @__PURE__ */ jsx(
            "span",
            {
              style: {
                position: "relative",
                display: "inline-block",
                width,
                minWidth: width,
                height,
                borderRadius: height / 2,
                background: value ? "#669FCC" : "#DDDDDD",
                border: "solid 1px",
                borderColor: value ? "#669FCC" : "#CCCCCC",
                transition: "0.1s"
              },
              children: /* @__PURE__ */ jsx(
                "span",
                {
                  style: {
                    position: "absolute",
                    top: padding,
                    left: !value ? padding + 1 : width - padding - sliderRadius - 2,
                    display: "inline-block",
                    width: sliderRadius,
                    height: sliderRadius,
                    borderRadius: sliderRadius / 2,
                    background: "#FFFFFF",
                    transition: "0.1s"
                  }
                }
              )
            }
          ),
          isNonNullable(label) && /* @__PURE__ */ jsx(
            "span",
            {
              className: classnames(isSmall ? "pl-1" : "pl-2"),
              style: {
                display: "inline-block",
                userSelect: "none",
                fontSize: isSmall ? "0.8em" : void 0
              },
              children: label
            }
          )
        ]
      }
    );
  }
);
ToggleSwitch.displayName = "ToggleSwitch";

export {
  ToggleSwitch
};
